import { Container } from "@mui/material";
import { BusquedaScopus } from "../../componentes/Scopus/BusquedaScopus";

export const BusqScopusPage:React.FC<{}> =() =>{
    return(
        <Container sx={{mt:4}}>
            <BusquedaScopus />
        </Container>
    );
}